export const MAX_COUNT_DATES_IN_PACKAGE_CARD = 3;
